module.exports = __webpack_public_path__ + "img/step2.fd8a1d57.svg";